import { DEFAULT_BAR_WIDTH, MAX_BAR_WIDTH } from '../constants/utils';
import calculateCartesianGridWidth from './calculateCartesianGridWidth';

// Calculates bar size based on available space (width of cartesian grid)
const calculateBarSize = (numItems: number, chartWidth: number): number => {
  if (chartWidth === 0) {
    return DEFAULT_BAR_WIDTH;
  }

  const cartesianGridWidth = calculateCartesianGridWidth(chartWidth);

  if (cartesianGridWidth < 0) {
    return DEFAULT_BAR_WIDTH;
  }

  const barWidth = Math.floor(cartesianGridWidth / numItems);
  return Math.min(barWidth, MAX_BAR_WIDTH);
};

export default calculateBarSize;
